import { StatsigClient } from "@statsig/js-client";
import userContext from "@modern/services/user_context";
import retailerContext from "@modern/services/retailer_context";

let statsigClient: StatsigClient | null = null;

export default async function initStatsig() {
  // Get the Statsig client SDK key from window.C (you'll need to add this to constants.js.erb)
  const statsigClientKey = window["C"]?.STATSIG_CLIENT_KEY;

  if (!statsigClientKey) {
    console.warn("Statsig client key not configured. Statsig will not be initialized.");
    return;
  }

  // Get user information from userContext
  const user = userContext.context.user;

  // Get current retailer
  const currentRetailer = retailerContext.get();

  // Build Statsig user object
  const statsigUser = {
    userID: user?.id?.toString() || "anonymous",
    email: user?.email,
    customIDs: {
      retailerID: currentRetailer?.id?.toString() || "anonymous",
    },
    custom: {
      retailerState: currentRetailer?.state,
    },
  };

  // Initialize Statsig client
  statsigClient = new StatsigClient(statsigClientKey, statsigUser, {
    environment: { tier: window["RAILS_ENV"] || "development" },
    // Uncomment to disable cache for testing:
    // disableLocalStorage: true,
  });

  // Initialize asynchronously (non-blocking)
  statsigClient.initializeAsync().catch(error => {
    console.error("Failed to initialize Statsig:", error);
  });

  // Make client accessible globally
  window["Statsig"] = statsigClient;
}

export function getStatsigClient(): StatsigClient | null {
  return statsigClient;
}
